import {Three as THREE, ThreeTsl as TSL} from "#material/three/exports"
import {ThreeColormassMaterial} from "#material/three/three-colormass-material"

class ShadowCatcherLightingModel extends THREE.LightingModel {
    override finish(builder: THREE.NodeBuilder) {
        const context = builder.getContext()

        const {outgoingLight, material} = context

        if (outgoingLight instanceof THREE.Node && material instanceof ThreeColormassMaterial) {
            const {uvShadowMapNode, uvShadowMapIntensityNode} = material
            // instanceof narrows to Node<unknown>; cast for TSL operations
            const ol = outgoingLight as THREE.Node<"vec3">

            if (uvShadowMapNode) {
                const uvShadowOcclusion = TSL.mix(
                    uvShadowMapNode.r,
                    TSL.float(1.0),
                    uvShadowMapIntensityNode ? TSL.sub(1.0, TSL.clamp(uvShadowMapIntensityNode, 0.0, 1.0)) : 0,
                )

                ol.assign(uvShadowOcclusion)
            } else ol.assign(1.0)
        }
    }
}

export class ThreeShadowCatcher extends ThreeColormassMaterial {
    private alpha = TSL.uniform(0.0)
    private bias = TSL.uniform(0.0)
    private falloffOffset = TSL.uniform(new THREE.Vector3(0, 0, 0))
    private falloffScale = TSL.uniform(new THREE.Vector3())
    private maskScale = TSL.uniform(0.0)

    override setupLightingModel() {
        const lightingModel = new ShadowCatcherLightingModel() as THREE.PhysicalLightingModel
        return lightingModel
    }

    constructor() {
        super()
        this.resetFilterParameters()

        const resolve = TSL.Fn(() => {
            const shadow = TSL.output.r.oneMinus()
            const mask = TSL.clamp(
                TSL.mul(TSL.sub(1.0, TSL.length(TSL.mul(TSL.sub(TSL.positionWorld, this.falloffOffset), this.falloffScale))), this.maskScale),
                0.0,
                1.0,
            ).smoothstep(0.0, 1.0)
            return TSL.vec4(0.0, 0.0, 0.0, TSL.mul(TSL.clamp(TSL.sub(TSL.mul(shadow, this.alpha), this.bias), 0.0, 1.0), mask))
        })

        this.outputNode = resolve()
    }

    setFilterParameters(parameters: {sizeX: number; sizeZ: number; smoothness: number; opacity: number; bias: number}) {
        this.alpha.value = parameters.opacity
        this.bias.value = parameters.bias
        this.falloffScale.value.set(1 / parameters.sizeX, 0, 1 / parameters.sizeZ)
        this.maskScale.value = 1.0 / parameters.smoothness
    }

    resetFilterParameters() {
        this.setFilterParameters({sizeX: 100000, sizeZ: 100000, smoothness: 1, opacity: 1, bias: 0.2})
    }
}
